import { useCallback } from 'react';

import { usePreviewEbookSubmissionMutation } from '../core/graphql/operation-hooks';
import { PintoPreviewEbookSubmissionInput } from '../core/graphql/types';

const useMutationPreviewEbookSubmission = () => {
  const [mutatePreviewEbookSubmission, { loading: isLoadingMutatePreviewEbookSubmission }] = usePreviewEbookSubmissionMutation({ errorPolicy: 'all' });

  const onMutatePreviewEbookSubmission = useCallback(
    async (input: PintoPreviewEbookSubmissionInput) => {
      try {
        const variables = { input };
        const res = await mutatePreviewEbookSubmission({ variables });
        if (res.errors) {
          return { success: false as const, errors: res.errors };
        }
        return { success: true as const, preview: res.data?.previewEbookSubmission };
      } catch {
        // errorPolicy: 'all' only folds GraphQL-response errors into res.errors above — a genuine
        // network failure still rejects this promise. Without this catch, selecting a file during
        // a network drop would throw unhandled and leave the admin with no preview and no error.
        return { success: false as const, errors: undefined };
      }
    },
    [mutatePreviewEbookSubmission],
  );

  return {
    onMutatePreviewEbookSubmission,
    isLoadingMutatePreviewEbookSubmission,
  };
};

export default useMutationPreviewEbookSubmission;
